import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const Wrapper = styled.div`
    flex: 1;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background-color: #21445a;
    margin: 10px;
`;

const Item = styled.div`
    width: 80%;
    height: 100px;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;     
    ${props => props.index > 0 && css`border-top:solid 2px white;`}
`;

const TextHighlight = styled.text`
    font-weight: bold;
    font-size: 45px;
    display: flex;
    flex-direction: column;
    margin-top: -10px;
`;

export default class StackedOrderedBox extends Component {
    static propTypes = {
        contentList: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            content: PropTypes.any
        }))
    }

    static defaultProps = {
        contentList: []
    }

    render() {
        const { contentList } = this.props
        return (
            <Wrapper>
                {contentList.map((item, index) => {
                    return (
                        <Item key={index} index={index}>
                            <p>
                                {item.title.toUpperCase()}
                                <br />
                                <TextHighlight>{item.content}</TextHighlight>
                            </p>
                        </Item>
                    );
                })}
            </Wrapper>
        );
    }

}


// WEBPACK FOOTER //
// ./src/module-analytics/components/StackedOrderedBox.js